// extracted by mini-css-extract-plugin
export default {"tabsContainer":"Tabs_tabsContainer__GV2Xl","tab":"Tabs_tab__vuSHs","tabActive":"Tabs_tabActive__US3y-","tabBadge":"Tabs_tabBadge__pgYuM"};